import React from 'react';

const isATInternet = typeof window !== 'undefined' && !!window.ATInternet;

const tag = isATInternet
  ? new window.ATInternet.Tracker.Tag()
  : {
      click: {
        send: ({ name, level2, type }: { name: string; level2: string; type: string }) => {
          console.log('Click ATInternet', name, level2, type);
        },
      },
    };

export default {
  send: (elem: React.ReactNode, name: string) =>
    tag.click.send({
      elem,
      name,
      level2: '14',
      type: 'navigation',
    }),
};
